import { Box } from '@cad-arc';
import { getArcHitColor } from '../utils';

export function UnreadIndicator({
    isRead,
    isHit,
}: {
    isRead: boolean;
    isHit: boolean;
}): React.ReactElement {
    return (
        <Box
            w="8px"
            h="8px"
            borderRadius="full"
            backgroundColor={getArcHitColor(isHit)}
            opacity={isRead ? 0 : isHit ? 1 : '70%'}
            marginLeft={1}
            marginRight={2}
            data-testid="dex-result-unread-indicator"
        />
    );
}
